import { useEffect } from "react";
import SDK from "../../config";

const TrackingScripts = () => {
  const head = document.querySelector("head");
  const addTwitterScript = () => {
    console.log("twitter script")
    const twitterScript = document.createElement("script");
    twitterScript.type = "text/javascript";
    twitterScript.async = true;
    twitterScript.src = "https://static.ads-twitter.com/uwt.js";
    head.appendChild(twitterScript);
  };

  const initializeTwq = (windowObj, documentObj, elementType) => {
    console.log(windowObj,  documentObj,  elementType);
    if (!windowObj.twq) {
      const twitterEventTracker = (windowObj.twq = (...args) => {
        twitterEventTracker.exe
          ? twitterEventTracker.exe.apply(twitterEventTracker, args)
          : twitterEventTracker.queue.push(args);
      });
      twitterEventTracker.version = "1.1";
      twitterEventTracker.queue = [];
      const twitterScriptElement = documentObj.createElement(elementType);
      twitterScriptElement.async = true;
      twitterScriptElement.src = "https://static.ads-twitter.com/uwt.js";
      const a = documentObj.getElementsByTagName(elementType)[0];
      a.parentNode.insertBefore(twitterScriptElement, a);
    }
  };

  useEffect(() => {
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      window.fbq("init", SDK.FB_PIXEL_ID);
    }

    // TikTok Pixel setup
    // (function (w, d, t) {
    //   w.TiktokAnalyticsObject = t;
    //   var ttq = (w[t] = w[t] || []);
    //   ttq.methods = [
    //     "page",
    //     "track",
    //     "identify",
    //     "instances",
    //     "debug",
    //     "on",
    //     "off",
    //     "once",
    //     "ready",
    //     "alias",
    //     "group",
    //     "enableCookie",
    //     "disableCookie",
    //     "holdConsent",
    //     "revokeConsent",
    //     "grantConsent",
    //   ];
    //   ttq.setAndDefer = function (t, e) {
    //     t[e] = function () {
    //       t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    //     };
    //   };
    //   for (var i = 0; i < ttq.methods.length; i++)
    //     ttq.setAndDefer(ttq, ttq.methods[i]);
    //   ttq.instance = function (t) {
    //     for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
    //       ttq.setAndDefer(e, ttq.methods[n]);
    //     return e;
    //   };
    //   ttq.load = function (e, n) {
    //     var r = "https://analytics.tiktok.com/i18n/pixel/events.js",
    //     // eslint-disable-next-line no-unused-vars
    //       o = n && n.partner;
    //     ttq._i = ttq._i || {};
    //     ttq._i[e] = [];
    //     ttq._i[e]._u = r;
    //     ttq._t = ttq._t || {};
    //     ttq._t[e] = +new Date();
    //     ttq._o = ttq._o || {};
    //     ttq._o[e] = n || {};
    //     n = document.createElement("script");
    //     n.type = "text/javascript";
    //     n.async = !0;
    //     n.src = r + "?sdkid=" + e + "&lib=" + t;
    //     e = document.getElementsByTagName("script")[0];
    //     e.parentNode.insertBefore(n, e);
    //   };

    //   ttq.load(SDK.TIK_TOK_PIXEL_ID);
    //   ttq.page();
    // })(window, document, "ttq");

    addTwitterScript();
    initializeTwq(window, document, "script");
    window.twq("config", SDK.X_PIXEL_ID);

    
  }, []);

  return null;
};

export default TrackingScripts;
